/**
 * APP_VERSION — a build-time ISO stamp (UTC date/time of the deploy) injected
 * via Vite's `define`. Falls back to "dev" when running outside a built bundle.
 * `typeof` guards against a ReferenceError when the token isn't replaced.
 */
declare const __APP_VERSION__: string;

export const APP_VERSION: string =
  typeof __APP_VERSION__ !== "undefined" ? __APP_VERSION__ : "dev";

/** Formats an ISO UTC version stamp to the user's local timezone. */
export function formatAppVersion(version: string): string {
  if (version === "dev") return "dev";
  const d = new Date(version);
  if (isNaN(d.getTime())) return version;
  return d.toLocaleString();
}

export const APP_VERSION_DISPLAY = formatAppVersion(APP_VERSION);
